exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".file-upload-panel{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.24);margin-bottom:20px;padding:18px}.file-upload-panel header{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}.file-upload-panel .file-attachments ul{list-style-type:none}.file-upload-panel .file-attachments ul li{-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;padding-top:.5em}.file-upload-panel .file-attachments ul li a,.file-upload-panel .file-attachments ul li button.button-link{-ms-flex:1 1 auto;flex:1 1 auto;width:calc(100% - 26px);word-wrap:break-word}.file-upload-panel .file-attachments ul li button.button-delete-icon{-ms-flex:0 0 16px;flex:0 0 16px;margin-left:10px}.file-upload-panel .icon-trash-can{height:20px;width:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/shared/components/file-attachment-panel/index.scss
// module id = 5259
// module chunks = 0